<script setup>
import {ref, onMounted, onBeforeUnmount} from "vue";

const props = defineProps({
  // 需要监听的滚动容器
  container: {
    required: true,
    type: String
  },
  // 锚点组件需要展示的内容
  links: {
    required: true,
    type: Array,
    default: [
      {
        // 锚点
        href: "#step1",
        // 标题
        title: "步骤1",
        // 是否填写完成;适配发布活动，默认情况下传false
        filled: false
      }
    ]
  }
})

// 点击跳转
const scrollTo = (href) => {
  const target = document.querySelector(href);
  if (target) {
    target.scrollIntoView({ behavior: "auto", block: "start" });
  }
};

onMounted(() => {
  // 获取容器信息
  scrollContainer = document.querySelector(props.container) || window
  // 设置监听器
  scrollContainer.addEventListener("scroll", onScroll, { passive: true })
  // 初始化执行一次
  onScroll()
});

// 组件注销前取消监听器监听
onBeforeUnmount(() => {
  if (scrollContainer) {
    scrollContainer.removeEventListener("scroll", onScroll)
  }
});

// 当前激活的href
const activeHref = ref("")
// 滚动容器
let scrollContainer = null

// 滚动监听
const onScroll = () => {
  if (!scrollContainer) return

  let current = ""
  props.links.forEach((item) => {
    const el = document.querySelector(item.href)
    if (el) {
      const rect = el.getBoundingClientRect();
      // rect.top 相对视口顶部的位置，<= 300 说明已进入视口
      if (rect.top <= 300) {
        current = item.href
      }
    }
  });
  activeHref.value = current;
};
</script>

<template>
  <div class="yt_anchor_box flex_center">
    <div v-for="(item, index) in props.links" :key="`anchor${index}`">
      <div class="flex_left">
        <div class="flex_left cursor-pointer" @click="scrollTo(item.href)">
          <div :class="['yt_anchor_pre_box mg_r_1 flex_center', { filled: item.filled }]">
            <div v-if="!item.filled">{{index + 1}}</div>
            <img v-else style="width: 19px;height: 13px;" src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/common/common/component_anchor_checked.svg"/>
          </div>
          <div :class="['yt_anchor_title', {active: activeHref === item.href}]">
            {{item.title}}
          </div>
        </div>
        <div class="yt_anchor_spacer" v-if="index + 1 < props.links.length"></div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.yt_anchor_box {
  box-sizing: border-box;
  padding: 35px 20px;
  .filled {
    background-color: #796CB4!important;
  }
  .yt_anchor_pre_box {
    width: 33px;
    height: 33px;
    background: #F3F3F3;
    border-radius: 50%;
    line-height: 33px;
  }
  .yt_anchor_title {
    color: #535F72;
  }
  .active {
    color: #000000;
    font-weight: 500!important;
  }
  .yt_anchor_spacer {
    width: 74px;
    height: 2px;
    background-color: #BABABA;
    margin: 0 15px;
  }
}

</style>
